/**
 * tpj-kill-legacy-popups.js  (TEMPORARY — added 2026-05-25)
 *
 * Klaviyo account Qv6sQ8 has 49 orphaned LEGACY sign-up forms that still render
 * via the onsite script but are invisible to the new Forms dashboard/API, so
 * they cannot be unpublished normally. Klaviyo support has been asked to delete
 * them. UNTIL THEY DO, this script removes ONLY those 49 forms by ID.
 *
 * IMPORTANT: This is keyed to the specific dead form IDs below. Any NEW Klaviyo
 * form/pop-up (different ID) is untouched and will display + work normally.
 *
 * REMOVE THIS FILE (and its <script> tag in layout/theme.liquid) once Klaviyo
 * support confirms the legacy forms are deleted.
 */
(function () {
  'use strict';
  var DEAD = {
    RWBwwN:1, RpW7Q9:1, VAGeku:1, RUZpdd:1, TTPbvc:1, Vyh2tQ:1, VbCjS6:1, LbuPK8:1,
    S8p3Vv:1, Xb9UmA:1, WsrHAK:1, XvNrCP:1, VsCPFA:1, V3mKZC:1, R7pHyJ:1, VyNidA:1,
    VqT7QV:1, RgYdMe:1, WiZUDW:1, XKXLF5:1, RpKhV3:1, XcGdde:1, WMbXva:1, UkyKSq:1,
    VX54vw:1, RGLmJh:1, XsvSTi:1, Skf8P4:1, U2rZNC:1, Un4Dmv:1, STSBAF:1, QYZfTM:1,
    WTCHZ8:1, VVQQws:1, Hrrjfz:1, VjVseM:1, QRGfPt:1, TYGVMd:1, SBarej:1, SSph5D:1,
    TUfbZB:1, Vw2Bgc:1, X6suDY:1, Ya6fdp:1, TaBFs8:1, Vskjz9:1, QXyFyc:1, TrRpjx:1,
    Rhj9hY:1
  };

  function deadId(el) {
    if (!el || !el.getAttribute) return null;
    var t = el.getAttribute('data-testid') || '';
    var m = t.match(/klaviyo-form-([A-Za-z0-9]+)/);
    if (m && DEAD[m[1]]) return m[1];
    var c = (el.className && el.className.baseVal !== undefined) ? el.className.baseVal : (el.className || '');
    c = '' + c;
    for (var id in DEAD) { if (c.indexOf('klaviyo-form-' + id) > -1) return id; }
    return null;
  }

  function clean() {
    var nodes = document.querySelectorAll('[data-testid^="klaviyo-form-"], [class*="klaviyo-form-"]');
    for (var i = 0; i < nodes.length; i++) {
      if (!deadId(nodes[i])) continue;
      // Remove the form's own Klaviyo wrapper (each form gets its own kl-private-reset-css-* container).
      var wrap = nodes[i].closest ? (nodes[i].closest('[class*="kl-private-reset-css"]') || nodes[i]) : nodes[i];
      try { wrap.remove(); } catch (e) {}
    }
    // Only unlock body scroll if NO live (non-dead) Klaviyo form remains — so a real new pop-up keeps its scroll lock.
    var live = false, all = document.querySelectorAll('[data-testid^="klaviyo-form-"]');
    for (var j = 0; j < all.length; j++) { if (!deadId(all[j])) { live = true; break; } }
    if (!live && document.body) document.body.classList.remove('klaviyo-prevent-body-scrolling');
  }

  clean();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', clean);
  try {
    new MutationObserver(clean).observe(document.documentElement, { childList: true, subtree: true });
  } catch (e) {}
})();
